const birthdateSvg = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.333 2.00008H12.9997C13.1765 2.00008 13.3461 2.07032 13.4711 2.19534C13.5961 2.32037 13.6663 2.48994 13.6663 2.66675V13.3334C13.6663 13.5102 13.5961 13.6798 13.4711 13.8048C13.3461 13.9298 13.1765 14.0001 12.9997 14.0001H0.999674C0.822863 14.0001 0.653294 13.9298 0.52827 13.8048C0.403246 13.6798 0.333008 13.5102 0.333008 13.3334V2.66675C0.333008 2.48994 0.403246 2.32037 0.52827 2.19534C0.653294 2.07032 0.822863 2.00008 0.999674 2.00008H3.66634V0.666748H4.99967V2.00008H8.99967V0.666748H10.333V2.00008ZM8.99967 3.33341H4.99967V4.66675H3.66634V3.33341H1.66634V6.00008H12.333V3.33341H10.333V4.66675H8.99967V3.33341ZM12.333 7.33341H1.66634V12.6667H12.333V7.33341Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default birthdateSvg
